(function () {
  var root = document.querySelector('[data-ap-monograms]');
  if (!root) return;

  function getInputs() { return root.querySelectorAll('[data-ap-filter-input]'); }
  function getItems()  { return root.querySelectorAll('[data-ap-item]'); }
  function getGroups() { return root.querySelectorAll('[data-ap-group]'); }
  var emptyMsg = root.querySelector('[data-ap-empty]');
  var clearBtns = root.querySelectorAll('[data-ap-clear-filters]');

  function collectActiveFilters() {
    var active = {};
    getInputs().forEach(function (inp) {
      if (!inp.checked) return;
      var name = inp.getAttribute('data-filter-name');
      if (!active[name]) active[name] = new Set();
      active[name].add(inp.value);
    });
    return active;
  }

  function itemMatches(item, active) {
    for (var name in active) {
      if (!Object.prototype.hasOwnProperty.call(active, name)) continue;
      var allowed = active[name];
      var attr = 'data-' + name.replace(/_/g, '-');
      var itemVals = (item.getAttribute(attr) || '').split(',').map(function (v) { return v.trim(); });
      var match = false;
      for (var i = 0; i < itemVals.length; i++) {
        if (allowed.has(itemVals[i])) { match = true; break; }
      }
      if (!match) return false;
    }
    return true;
  }

  function applyFilters() {
    var active = collectActiveFilters();
    var anyActive = Object.keys(active).length > 0;
    var totalVisible = 0;

    getItems().forEach(function (item) {
      var visible = !anyActive || itemMatches(item, active);
      item.classList.toggle('ap-monograms__item--hidden', !visible);
      if (visible) totalVisible++;
    });

    getGroups().forEach(function (g) {
      var visibleInGroup = g.querySelectorAll('[data-ap-item]:not(.ap-monograms__item--hidden)').length;
      g.classList.toggle('ap-monograms__group--hidden', visibleInGroup === 0);
    });

    if (emptyMsg) emptyMsg.hidden = !(anyActive && totalVisible === 0);
    clearBtns.forEach(function (btn) { btn.hidden = !anyActive; });
  }

  function clearAll() {
    getInputs().forEach(function (inp) { inp.checked = false; });
    applyFilters();
  }

  root.addEventListener('change', function (e) {
    if (e.target && e.target.matches('[data-ap-filter-input]')) applyFilters();
  });
  clearBtns.forEach(function (btn) { btn.addEventListener('click', clearAll); });

  // Expose so the loader can call it after rendering new items
  window.apMonogramsApplyFilters = applyFilters;

  applyFilters();
})();
